import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const IncidentPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.incident.pageHeader.title')} />
}

IncidentPageHeader.displayName = 'IncidentPageHeader'
export default IncidentPageHeader
